module.exports = __webpack_public_path__ + "img/img_16.2b9ec361.webp";